/**
 * React 应用入口
 *
 * 职责:
 * 1. 挂载 React 根组件
 * 2. 配置 React Query
 * 3. 配置路由
 */

import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { setupIosViewportHeightSync } from './hooks/use-ios-viewport-height'
import './theme/brandTokens.css'
import './chat/ui/theme/chat-gui-theme.css'
import './chat/ui/theme/chat-gui-mobile.css'
import './chat/ui/theme/chat-gui-mobile-canvas.css'
import './chat/ui/theme/chat-gui-mobile-session.css'
import './chat/ui/theme/chat-gui-compact-recommendation.css'
import './chat/ui/theme/chat-timeline-scrollbar.css'
import './chat/ui/theme/context-gauge.css'
import './chat/ui/theme/streaming-motion.css'
import './chat/ui/session/session-navigation.css'
import './chat/ui/theme/loading-state.css'
import './chat/ui/theme/thinking-process-status.css'
import './chat/ui/theme/staged-entry.css'
import './chat/ui/theme/collection-scroll-edges.css'
import './chat/ui/workspace/project-collection.css'
import './chat/ui/workspace/project-management.css'
import './chat/ui/workspace/source-collection.css'
import './chat/ui/capabilities/skill-management.css'
import './chat/ui/capabilities/settings-management.css'
import './chat/ui/feedback/async-content-boundary.css'
import './chat/ui/composer/composer-mode-control.css'
import 'streamdown/styles.css'
import './index.css'
import './styles/ios-safari.css'
import './theme/xiaocaiFlareTheme.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

setupIosViewportHeightSync()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
)
